
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, filter, catchError } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class SearchService {
    constructor (
    private http: HttpClient,
    ) {}

    searchwith2filter<T> (terms: Observable<T>, suffix: string, filtertarget: string, filterkey1: string, filterkey2: string): Observable<any> {
        return terms.pipe(
            debounceTime(100),
            distinctUntilChanged(),
            switchMap(term => this.searchEntries(term, suffix)),
            filter((data) => {
                if (filterkey1 && filterkey2) {
                    return data[filterkey1][filterkey2] === filtertarget;
                } else {
                    return data[filterkey1] === filtertarget;
                }
            })
        );
    }

    search<T> (terms: Observable<T>, suffix: string): Observable<any> {
        return terms.pipe(
            debounceTime(100),
            distinctUntilChanged(),
            switchMap(term => this.searchEntries(term, suffix))
        );
    }

    searchEntries(obj: any, suffix: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': ''
            })
        };
        return this.http.post('api/trafics/' + suffix, { body: obj }, httpOptions).pipe(
            catchError(res => of(res))
        );
    }

    searchRatehawk(obj: any, suffix: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ngsw-bypass': ''
            })
        };
        return this.http.post('api/ratehawk/' + suffix, { body: obj }, httpOptions).pipe(
            catchError(res => of(res))
        );
    }
}
